export default "__VITE_ASSET__3e14d98a__"